import { Message } from '../../models/message.model';
import { SmsCodeService } from '../../services/sms-code.service';
import { Member } from '../../models/member.model';
import { User } from '../../services/auth.service';
import { TeamsService } from '../../services/teams.service';
import { MessageMedia } from '../../models/message-media.model';
import { ConfigService } from '../../services/config.service';
import { IonTextarea, ModalController } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { IapService } from '../../services/iap.service';
import { Team } from '../../models/team.model';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController } from '@ionic/angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AppTrial } from '../../models/app-trial.model';
import { OverlayEventDetail } from '@ionic/core';
import { IAPModal } from '../iap-modal/iap-modal';
import { IAPBrowserModal } from '../iap-browser-modal/iap-browser-modal';
import { MediaService } from '../../services/media.service';
// import { Storage } from '@ionic/storage';
import {
  CaptureError,
  CaptureVideoOptions,
  MediaCapture,
  MediaFile,
} from '@ionic-native/media-capture/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { Storage } from '@ionic/storage';
const MEDIA_FOLDER_NAME = 'my_media';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import {
  VideoEditor,
  CreateThumbnailOptions,
} from '@ionic-native/video-editor/ngx';
import { AngularFireStorage } from '@angular/fire/storage';
import { AnalyticsService } from '../../services/analytics.service';

const MEDIA_FILES_KEY = 'mediaFiles';

@Component({
  selector: 'add-message-form',
  templateUrl: './add-message-form.component.html',
  styleUrls: ['./add-message-form.component.scss'],
})
export class AddMessageFormComponent implements OnInit, OnChanges {
  @Input() teamId: string;
  @Input() message: string;
  @Input() messages: boolean;
  @Input() title: string;
  @Input() placeholder: string;
  @Input() trial: AppTrial;
  @Input() team: Team;
  @Input() isUserAdmin: boolean;
  @Input() iconPosition: string;
  @Input() latestMessage: Message;
  @Input() userData: User;
  @Input() members: Member[];
  @Input() member: Member;

  @Output() public messageChange = new EventEmitter();
  @Output() public broadcastSet = new EventEmitter();

  @ViewChild('messageInput', { static: false }) messageInput: IonTextarea;
  @ViewChild('myvideo') myVideo: any;

  blocked = false;
  messageForm: FormGroup;
  lengthLimit = 1600;
  mode = 'text';
  messageMedia: MessageMedia[];
  uploadCount = 0;
  fileCount = 0;
  errMsg = 'wtf';

  // >>> LATEST MEDIA FEATURES
  fileList: FileList;
  files = [];
  uploads = [];
  uploadProgress = 0;
  // <<< LATEST MEDIA FEATURES

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
    public toastController: ToastController,
    public iap: IapService,
    public actionSheetController: ActionSheetController,
    private mediaCapture: MediaCapture,
    public config: ConfigService,
    public translate: TranslateService,
    private fb: FormBuilder,
    public file: File,
    private storage: Storage,
    public mediaService: MediaService,
    // >>> LATEST MEDIA FEATURES
    public teamsService: TeamsService,
    private plt: Platform,
    private videoEditor: VideoEditor,
    private imagePicker: ImagePicker,
    private sms: SmsCodeService,
    private afStorage: AngularFireStorage // <<< LATEST MEDIA FEATURES
  ) {}

  ngOnInit() {
    this.message = this.defaultMessage();
    this.setFormValues(this.message);
    // >>> LATEST MEDIA FEATURES
    this.plt.ready().then(() => {
      if (this.iap.isMobileApp()) {
        const path = this.file.dataDirectory;
        this.file.checkDir(path, MEDIA_FOLDER_NAME).then(
          () => {
            this.loadFiles();
          },
          (err) => {
            this.file.createDir(path, MEDIA_FOLDER_NAME, false).then(() => {
              this.loadFiles();
            });
          }
        );
      } else {
        this.analytics.track('qt_err_no_device', {
          crash: false,
          fatal: false,
          source: 'add-message-form',
          in_func: 'ngOnInit',
          msg: 'Not on device',
        });
        console.log('Not on mobile, ignoring media features');
      }
    });
    // <<< LATEST MEDIA FEATURES
  }

  ngOnChanges(changes) {
    console.log('addMessageForm onChanges');
    const currentTrial = changes?.trial?.currentValue?.status ?? null;
    const previousTrial = changes?.trial?.previousValue?.status ?? null;
    const currentExpiration =
      changes?.team?.currentValue?.teamPlan?.expires ?? null;
    const previousExpiration =
      changes?.team?.previousValue?.teamPlan?.expires ?? null;
    console.log('changes', changes);
    if (
      (!!currentExpiration && previousExpiration === null) ||
      (!!currentExpiration &&
        !!previousExpiration &&
        currentExpiration !== previousExpiration) ||
      (currentTrial === 'active' && previousTrial === null)
    ) {
      console.log('Recheck status in case purchase was pending and just made');
      if (this.blocked) {
        console.log('BLOCKED');
        if (!this.iap.hasValidPlan(this.isUserAdmin, this.trial, this.team)) {
          console.log('invalid plan, block the team');
          this.blocked = true;
        } else {
          console.log('valid plan, unblock the team');
          this.blocked = false;
          if (this.team.teamAdminId === this.userData.uid) {
            this.onMessageDone();
          }
        }
      } else {
        console.log('NOT blocked');
        this.setFormValues(this.message);
      }
    } else {
      console.log(
        'some other changes',
        currentExpiration,
        previousExpiration,
        changes
      );
    }
  }

  ionViewDidLoad() {
    // this.storage.get(MEDIA_FILES_KEY).then((res) => {
    //   this.media.mediaFiles = JSON.parse(res) || [];
    // });
  }

  ionViewDidEnter() {
    /*
    setTimeout(() => {
      this.messageInput.setFocus();
    }, 300);
    */
  }

  setFormValues(msg) {
    this.messageForm = this.fb.group({
      message: [
        msg,
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(this.lengthLimit),
        ],
      ],
    });
  }

  async required(errMsg: string) {
    const toast = await this.toastController.create({
      message: this.translate.instant(errMsg),
      duration: 2000,
      color: 'danger',
    });
    toast.present();
  }

  enforceFormat(event) {
    // Input must be of a valid number format or a modifier key, and not longer than ten digits
    if (this.messageForm.get('message').value.length >= this.lengthLimit) {
      event.preventDefault();
    }
  }

  hasValidMessage() {
    if (this.messageForm.get('message').value.length > 0) {
      return true;
    }
    return false;
  }

  async iapModal() {
    // console.log('iapModal');

    const modal = await this.modalCtrl.create({
      component: IAPModal,
      componentProps: {
        teamId: this.teamId,
        message: this.message,
        messages: this.messages,
        title: this.title,
        placeholder: this.placeholder,
        trial: this.trial,
        team: this.team,
        isUserAdmin: this.isUserAdmin,
      },
    });

    modal.onWillDismiss().then((modal: OverlayEventDetail) => {});
    return await modal.present();
  }

  async iapBrowserModal() {
    // console.log('iapModal');

    const modal = await this.modalCtrl.create({
      component: IAPBrowserModal,
      componentProps: {
        teamId: this.teamId,
        message: this.message,
        messages: this.messages,
        title: this.title,
        placeholder: this.placeholder,
        trial: this.trial,
        team: this.team,
        isUserAdmin: this.isUserAdmin,
      },
    });

    modal.onWillDismiss().then((modal: OverlayEventDetail) => {});
    return await modal.present();
  }

  sendIconStyle() {
    let classVal = '';

    if (this.hasValidMessage()) {
      classVal = classVal + ' send-button-highlight';
    }

    return classVal;
  }

  setFocus() {
    //console.log('setFocus');
    //console.log( this.messageInput );
    /*
    setTimeout(() => {
      this.messageInput.setFocus();
    }, 300);
    */
  }

  closeCamera() {
    this.mode = 'text';
  }

  closeAudio() {
    this.mode = 'text';
    this.mediaService.clearAudio();
  }

  // recordAudio() {
  //   this.mode = 'audio';
  // }

  async imageActionSheet() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Select Image Source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.mediaService.pickImage(
              this.mediaService.camera.PictureSourceType.PHOTOLIBRARY
            );
          },
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.mediaService.pickImage(
              this.mediaService.camera.PictureSourceType.CAMERA
            );
          },
        },
        {
          text: 'Use Camera For Video',
          handler: () => {
            this.captureVideo();
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
        },
      ],
    });
    await actionSheet.present();
  }

  captureVideo() {
    const options: CaptureVideoOptions = {
      limit: 1,
      duration: 30,
    };
    this.mediaCapture.captureVideo(options).then(
      (res: MediaFile[]) => {
        const capturedFile = res[0];
        // this.mediaFiles = res;
        // alert(JSON.stringify(capturedFile));
        const fileName = capturedFile.name;
        const dir = capturedFile['localURL'].split('/');
        dir.pop();
        const fromDirectory = dir.join('/');
        const toDirectory = this.file.dataDirectory;

        // const video = this.myVideo.nativeElement;
        // console.log('file url:', fromDirectory, fileName);
        // video.src = fromDirectory + fileName;
        // video.play();
        console.log(
          'capture info:',
          fromDirectory,
          fileName,
          toDirectory,
          fileName
        );
        this.file.copyFile(fromDirectory, fileName, toDirectory, fileName).then(
          (fileResource) => {
            this.storeMediaFiles([{ name: fileName, size: capturedFile.size }]);
          },
          (err) => {
            console.log('captureVideo err: ', err);
          }
        );
      },
      (err: CaptureError) => console.error(err)
    );
  }

  storeMediaFiles(files) {
    console.log('store:', files);
    this.storage.get(MEDIA_FILES_KEY).then((res) => {
      if (res) {
        let arr = JSON.parse(res);
        arr = arr.concat(files);
        this.storage.set(MEDIA_FILES_KEY, JSON.stringify(arr));
      } else {
        this.storage.set(MEDIA_FILES_KEY, JSON.stringify(files));
      }
      this.files = this.files.concat(files);
    });
  }

  // >>> LATEST MEDIA FEATURES
  loadFiles() {
    this.file
      .listDir(this.file.dataDirectory, MEDIA_FOLDER_NAME)
      .then((res) => {
        this.files = res;
        console.log('files: ', res);
      });
  }

  async selectMedia() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Add Media',
      subHeader: 'What would you like to do?',
      buttons: [
        {
          text: 'Take Picture',
          handler: () => {
            this.captureImage();
          },
        },
        {
          text: 'Record Video',
          handler: () => {
            this.recordVideo();
          },
        },
        // {
        //   text: 'Record Audio',
        //   handler: () => {
        //     this.recordAudio();
        //   },
        // },
        {
          text: 'Pick from Library',
          handler: () => {
            // this.pickImages();
            this.mediaService.pickMedia().then(
              (mediaPath) => {
                console.log('picked media: ', mediaPath);
                if (mediaPath.endsWith('.MOV') || mediaPath.endsWith('.qt')) {
                  console.log('picked a quicktime video');
                  this.videoPicked(mediaPath);
                } else if (mediaPath.endsWith('.jpg')) {
                  console.log('picked an image');
                  this.copyFileToLocalDir(mediaPath);
                } else {
                  alert(`picked an unknown media type: ${mediaPath}`);
                }
              },
              (err) => {
                // Handle error
                console.log('Library error:' + err);
              }
            );
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
        },
      ],
    });
    await actionSheet.present();
  }

  pickImages() {
    this.imagePicker.getPictures({ allow_video: true }).then((results) => {
      console.log('images: ', results);
      // for (let result of results) {
      //   this.copyFileToLocalDir(result);
      // }
    });
  }

  captureImage() {
    this.mediaCapture.captureImage().then((data: MediaFile[]) => {
      if (data.length > 0) {
        this.copyFileToLocalDir(data[0].fullPath);
      }
    });
  }

  recordAudio() {
    this.mediaCapture.captureAudio().then(
      (data: MediaFile[]) => {
        if (data.length > 0) {
          this.copyFileToLocalDir(data[0].fullPath);
        }
      },
      (err: CaptureError) => console.error(err)
    );
  }

  recordVideo() {
    this.mediaCapture.captureVideo().then(
      (data: MediaFile[]) => {
        if (data.length > 0) {
          this.videoCaptured(data[0]);
        }
      },
      (err: CaptureError) => console.error(err)
    );
  }

  copyFileToLocalDir(fullPath) {
    console.log('copy now: ', fullPath);
    let myPath = fullPath;
    // Make sure we copy from the right location
    if (fullPath.indexOf('file://') < 0) {
      myPath = 'file://' + fullPath;
    }

    // const ext = myPath.split('.').pop();
    const name = myPath.substr(myPath.lastIndexOf('/') + 1);
    const copyFrom = myPath.substr(0, myPath.lastIndexOf('/') + 1);
    const copyTo = this.mediaFolder();
    console.log('from: ', copyFrom);
    console.log('tp: ', copyTo);
    console.log('name: ', name);
    const ext = myPath.split('.').pop();
    const d = Date.now();
    const newName = `${d}.${ext}`;

    this.file.copyFile(copyFrom, name, copyTo, newName).then(
      () => {
        this.loadFiles();
      },
      (err) => console.log('error: ', err)
    );
  }

  removePreview(f, path) {
    const preview = `${f.name.replace(/.mp4/, '')}.preview.jpg`;
    console.log('removed a video, remove preview too', path, preview);
    this.file.removeFile(path, preview).then(
      () => {
        console.log('removed preview', preview, path);
      },
      (err) => {
        if (err.message !== 'NOT_FOUND_ERR') {
          console.log('error removing preview', err);
        }
      }
    );
  }

  removeMp4Source(quicktimeFileEntry) {
    const path = quicktimeFileEntry.nativeURL.substr(
      0,
      quicktimeFileEntry.nativeURL.lastIndexOf('/') + 1
    );
    const sourceFileName = quicktimeFileEntry.name;
    console.log('remove mp4 quicktime source file', path, sourceFileName);
    this.file.removeFile(path, sourceFileName).then(
      () => {
        console.log('removed mp4 quicktime source file', sourceFileName, path);
      },
      (err) => {
        if (err.message !== 'NOT_FOUND_ERR') {
          console.log('error removing mp4 quicktime source file', err);
        }
      }
    );
  }

  deleteFile(f: FileEntry) {
    const path = f.nativeURL.substr(0, f.nativeURL.lastIndexOf('/') + 1);

    this.file.removeFile(path, f.name).then(
      async () => {
        if (f.name.endsWith('.mp4')) {
          await this.removePreview(f, path);
          this.loadFiles();
        } else {
          console.log('removed a picture or audio');
          this.loadFiles();
        }
      },
      (err) => console.log('error removing file: ', err)
    );
  }

  mediaWillLoad(event, media) {
    // console.log('mediaWillLoad');
    media.loaded = false;
  }

  mediaDidLoad(event, media) {
    media.loaded = true;
    // console.log('mediaDidLoad');
  }

  async videoPicked(mediaPath) {
    console.log('videoPicked, do something different to process it', mediaPath);
    const quicktimeFileEntry = await this.moveQuicktimeToLocal(mediaPath);
    const transcodedVideoPath = await this.transcodeQuicktimeToMp4(
      quicktimeFileEntry,
      mediaPath
    );
    this.removeMp4Source(quicktimeFileEntry); // No need to await for this to happen
    const mp4FileEntry = await this.moveMp4ToLocal(transcodedVideoPath);
    const thumbnailPath = await this.createThumbnailFromMp4(mp4FileEntry);
    await this.moveThumbnailToLocal(thumbnailPath, mp4FileEntry);
    // Update the displayed list
    await this.loadFiles();
  }

  async videoCaptured(mediaFile: MediaFile) {
    console.log('process captured video file', mediaFile);
    const quicktimeFileEntry = await this.moveQuicktimeToLocal(
      mediaFile.fullPath
    );
    const transcodedVideoPath = await this.transcodeQuicktimeToMp4(
      quicktimeFileEntry,
      quicktimeFileEntry.nativeURL.replace('file://', '')
    );

    this.removeMp4Source(quicktimeFileEntry); // No need to await for this to happen

    const mp4FileEntry = await this.moveMp4ToLocal(transcodedVideoPath);
    const thumbnailPath = await this.createThumbnailFromMp4(mp4FileEntry);
    await this.moveThumbnailToLocal(thumbnailPath, mp4FileEntry);

    const retranscodedMp4VideoPath = await this.retranscodeMp4ToMp4(
      mp4FileEntry,
      mp4FileEntry.nativeURL.replace('file://', '')
    );
    console.log('retranscodedMp4VideoPath', retranscodedMp4VideoPath);
    const mp4FileEntryRetranscoded = await this.moveMp4ToLocal(
      retranscodedMp4VideoPath
    );
    const thumbnailPathRetranscoded = await this.createThumbnailFromMp4(
      mp4FileEntryRetranscoded
    );
    await this.moveThumbnailToLocal(
      thumbnailPathRetranscoded,
      mp4FileEntryRetranscoded
    );

    // Update the displayed list
    await this.loadFiles();
  }

  async createThumbnailFromMp4(mp4FileEntry) {
    const options: CreateThumbnailOptions = {
      fileUri: mp4FileEntry.nativeURL,
      outputFileName: `${mp4FileEntry.name.replace(/.mp4/, '')}.preview`,
      atTime: 0.2,
      width: 320,
      height: 480,
      quality: 100,
    };
    const thumbnailPath = await this.videoEditor.createThumbnail(options);
    console.log('mp4 thumbnail path', thumbnailPath);
    return thumbnailPath;
  }

  async moveThumbnailToLocal(thumbnailPath, mp4FileEntry) {
    // Make sure we copy from the right location
    if (thumbnailPath.indexOf('file://') < 0) {
      thumbnailPath = 'file://' + thumbnailPath;
    }
    console.log(`copy thumbnail spec '${thumbnailPath}'`);
    const fromPath = thumbnailPath.substr(
      0,
      thumbnailPath.lastIndexOf('/') + 1
    );
    console.log(`copy thumbnail spec '${thumbnailPath}'`);
    const thumbnailName = `${mp4FileEntry.name.replace(
      /.mp4/,
      ''
    )}.preview.jpg`;
    console.log(`copy thumbnail name '${thumbnailName}'`);
    this.file.copyFile(
      fromPath,
      thumbnailName,
      this.mediaFolder(),
      thumbnailName
    );
  }

  mediaFolder() {
    return this.file.dataDirectory + MEDIA_FOLDER_NAME;
  }

  async moveMp4ToLocal(transcodedVideoPath) {
    // Make sure we copy from the right location
    if (transcodedVideoPath.indexOf('file://') < 0) {
      transcodedVideoPath = 'file://' + transcodedVideoPath;
    }

    const transcodedName = transcodedVideoPath.substr(
      transcodedVideoPath.lastIndexOf('/') + 1
    );
    const copyTranscodedFrom = transcodedVideoPath.substr(
      0,
      transcodedVideoPath.lastIndexOf('/') + 1
    );
    const copyTranscodedTo = this.file.dataDirectory + MEDIA_FOLDER_NAME;
    console.log('copy transcoded from: ', copyTranscodedFrom);
    console.log('copy transcoded to: ', copyTranscodedTo);
    console.log('copy transcoded name: ', transcodedName);
    const mp4FileEntry = await this.file.copyFile(
      copyTranscodedFrom,
      transcodedName,
      copyTranscodedTo,
      transcodedName
    );
    console.log('mp4 local file entry', mp4FileEntry);
    return mp4FileEntry;
  }

  async moveQuicktimeToLocal(videoPath) {
    console.log('copy video: ', videoPath);

    // Make sure we copy from the right location
    if (videoPath.indexOf('file://') < 0) {
      videoPath = 'file://' + videoPath;
    }

    const name = videoPath.substr(videoPath.lastIndexOf('/') + 1);
    const copyFrom = videoPath.substr(0, videoPath.lastIndexOf('/') + 1);
    const copyTo = this.mediaFolder();
    console.log('copy from: ', copyFrom);
    console.log('copy to: ', copyTo);
    console.log('copy name: ', name);
    const ext = videoPath.split('.').pop();
    const d = Date.now();

    const quicktimeFileEntry = await this.file.copyFile(
      copyFrom,
      name,
      copyTo,
      `${d}.${ext}`
    );
    console.log('quicktime file entry', quicktimeFileEntry);
    return quicktimeFileEntry;
  }

  async transcodeQuicktimeToMp4(localEntry, mediaPath) {
    console.log('transcoding quicktime to mp4', localEntry, mediaPath);
    const VideoEditorOptions = {
      OptimizeForNetworkUse: {
        NO: 0,
        YES: 1,
      },
      OutputFileType: {
        M4V: 0,
        MPEG4: 1,
        M4A: 2,
        QUICK_TIME: 3,
      },
    };
    const ext = localEntry.fullPath.split('.').pop();
    const videoFileName =
      ext === 'MOV'
        ? localEntry.name.replace(/.MOV/, '')
        : localEntry.name.replace(/.qt/, '');
    console.log(`transcoding quicktime to ${videoFileName}`);

    const transcodedVideoPath = await this.videoEditor.transcodeVideo({
      fileUri: mediaPath,
      outputFileName: videoFileName,
      outputFileType: VideoEditorOptions.OutputFileType.MPEG4,
      optimizeForNetworkUse: VideoEditorOptions.OptimizeForNetworkUse.YES,
      saveToLibrary: false,
      maintainAspectRatio: true,
      width: 640,
      height: 640,
      videoBitrate: 1000000, // 1 megabit
      audioChannels: 2,
      audioSampleRate: 44100,
      audioBitrate: 128000, // 128 kilobits
      progress: (info) => {
        console.log('transcode mp4 progress, info: ' + info);
      },
    });
    console.log('transcoded mp4 path', transcodedVideoPath);

    return transcodedVideoPath;
  }

  async retranscodeMp4ToMp4(localEntry, mediaPath) {
    console.log('transcoding quicktime to mp4', localEntry, mediaPath);
    const VideoEditorOptions = {
      OptimizeForNetworkUse: {
        NO: 0,
        YES: 1,
      },
      OutputFileType: {
        M4V: 0,
        MPEG4: 1,
        M4A: 2,
        QUICK_TIME: 3,
      },
    };
    const d = Date.now();
    const videoFileName = `${d}`;
    console.log(`retranscoding quicktime to ${videoFileName}`);
    const transcodedVideoPath = await this.videoEditor.transcodeVideo({
      fileUri: mediaPath,
      outputFileName: videoFileName,
      outputFileType: VideoEditorOptions.OutputFileType.MPEG4,
      optimizeForNetworkUse: VideoEditorOptions.OptimizeForNetworkUse.YES,
      saveToLibrary: false,
      maintainAspectRatio: true,
      width: 640,
      height: 640,
      videoBitrate: 1000000, // 1 megabit
      audioChannels: 2,
      audioSampleRate: 44100,
      audioBitrate: 128000, // 128 kilobits
      progress: (info) => {
        console.log('retranscode mp4 progress, info: ' + info);
      },
    });
    console.log('retranscoded mp4 path', transcodedVideoPath);

    return transcodedVideoPath;
  }

  videoTranscodeSuccess(result) {
    // result is the path to the transcoded video on the device
    console.log('videoTranscodeSuccess, result: ' + result);
  }

  videoTranscodeError(err) {
    console.log('videoTranscodeError, err: ' + err);
  }

  createThumbnailSuccess(result) {
    // result is the path to the jpeg image on the device
    console.log('createThumbnailSuccess, result: ' + result);
  }

  createThumbnailError(err) {
    console.log('createThumbnailError, result: ' + err);
  }

  onMessageDone() {
    this.analytics.track('qt_broadcast_send', {
      ui: true,
      team_id: this.teamId,
    });

    console.log(
      `onMessageDone: ${!this.iap.hasValidPlan(
        this.isUserAdmin,
        this.trial,
        this.team
      )}`
    );

    if (!this.iap.hasValidPlan(this.isUserAdmin, this.trial, this.team)) {
      this.blocked = true;
      this.analytics.track('qt_broadcast_send_blocked', {
        team_id: this.teamId,
      });
      // if (!this.iap.isMobileApp()) {
      //   this.iapBrowserModal();
      //   return;
      // } else {
      this.iapModal();
      // }
      return;
    }

    if (this.hasValidMessage()) {
      this.message = this.messageForm.get('message').value;
      this.setFormValues('');
      this.messageMedia = [];
      this.uploads = this.files.filter((f) => {
        return !f.name.endsWith('.preview.jpg');
      });
      this.fileCount = this.uploads.length;
      if (this.fileCount > 0) {
        this.uploadCount = 0;
        this.uploadFile();
      } else {
        // Broadcast?
        if (!this.member) {
          this.messageQueue(this.message);
        } else {
          // Reply
          this.sendReply();
        }
      }
    } else {
      this.analytics.track('qt_input_invalid', {
        source: 'add-message-form',
        input: 'message',
      });
      this.errMsg = 'Type a message to send.';
      this.required(this.errMsg);
    }
  }

  async sendReply() {
    console.log(`send new reply: '${this.message}'`);
    const messageId = this.latestMessage.messageId;
    this.analytics.track('qt_reply_send', { message_id: messageId });

    await this.teamsService.replyByStaff({
      teamId: this.teamId,
      messageId,
      replyType: 'message',
      memberId: this.member.memberId,
      replyText: this.message,
      senderId: this.userData.uid,
      media: this.messageMedia,
      senderName: `${this.userData.firstName} ${this.userData.lastName}`,
    });
    this.message = this.defaultMessage();
    this.messageMedia = [];
    // IonContent Scroll: Toggle message sent flag
    this.broadcastSet.emit(true);
  }

  async uploadFile() {
    const f: FileEntry = this.uploads[this.uploadCount];
    const path = f.nativeURL.substr(0, f.nativeURL.lastIndexOf('/') + 1);
    const mime = this.getMimeType(f.name.split('.').pop());
    const buffer = await this.file.readAsArrayBuffer(path, f.name);
    const fileBlob = new Blob([buffer], mime);

    const randomId = Math.random().toString(36).substring(2, 8);

    const uploadTask = this.afStorage.upload(
      `files/${new Date().getTime()}_${randomId}`,
      fileBlob
    );

    this.uploadProgress = 1;

    uploadTask.percentageChanges().subscribe((change) => {
      this.uploadProgress = change;
      console.log(`Upload ${change}% complete...`);
    });

    try {
      uploadTask.then(async (res) => {
        console.log('File upload finished!', res);
        this.uploadProgress = 0;
        const downloadUrl = await res.ref.getDownloadURL();
        console.log('downloadUrl', downloadUrl);
        this.messageMedia.push({
          type: mime.type,
          url: downloadUrl,
        });
        this.uploadCount++;
        console.log(`uploaded ${this.uploadCount} files`);
        if (this.uploadCount < this.fileCount) {
          console.log(
            `${this.uploads.length - this.uploadCount} more to upload`
          );
          this.uploadFile();
        } else {
          console.log(`uploaded all ${this.uploadCount} files`);
          for (let i = 0; i < this.fileCount; i++) {
            this.deleteFile(this.uploads[i]);
          }
          // Broadcast?
          if (!this.member) {
            this.messageQueue(this.message);
          } else {
            // Reply
            this.sendReply();
          }
        }
      });
    } catch (error) {
      console.log('upload error', error);
    }
  }

  async messageQueue(msg) {
    console.log(`send new broadcast: '${this.message}'`);
    const teamId = this.teamId;
    this.analytics.track('qt_broadcast_queue', { team_id: teamId });
    await this.teamsService.messageQueue(
      {
        messageTeamId: teamId,
        messageType: 'broadcast',
        messageText: msg,
        messageSenderName: `${this.userData.firstName} ${this.userData.lastName}`,
        media: this.messageMedia,
      },
      this.members
    );
    this.message = this.defaultMessage();
    this.messageMedia = [];
    this.broadcastSet.emit(false);
  }

  getMimeType(fileExt) {
    if (fileExt === 'wav') {
      return { type: 'audio/wav' };
    } else if (fileExt === 'jpg') {
      return { type: 'image/jpg' };
    } else if (fileExt === 'MOV') {
      return { type: 'video/quicktime' };
    } else if (fileExt === 'mp4') {
      return { type: 'video/mp4' };
    }
  }
  // <<< LATEST MEDIA FEATURES

  setMessageById(id) {
    // this.message = this.defaultMessage();
    this.message = this.translate.instant(id);
    this.setFormValues(this.message);
    console.log(`User requested '${this.message}'`);
    this.broadcastSet.emit(true);
  }

  defaultMessage() {
    return '';
  }

  pickTemplate(templateId) {
    const template = this.translate.instant(templateId);
    this.analytics.track('qt_broadcast_template', {
      team_id: this.teamId,
      ui: true,
      template,
    });
    this.setMessageById(templateId);
  }

  async messageActionSheet() {
    this.analytics.track('qt_broadcast_templates', {
      team_id: this.teamId,
      ui: true,
    });
    const options = {
      header: `${this.translate.instant('MESSAGES.LABELS.MESSAGE_OPTIONS')}`,
      buttons: [
        {
          text: this.translate.instant('MESSAGES.TEMPLATES.LABEL_1'),
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            this.pickTemplate('MESSAGES.TEMPLATES.LABEL_1');
          },
        },
        {
          text: this.translate.instant('MESSAGES.TEMPLATES.LABEL_2'),
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            this.pickTemplate('MESSAGES.TEMPLATES.LABEL_2');
          },
        },
        {
          text: this.translate.instant('MESSAGES.TEMPLATES.LABEL_3'),
          // role: 'destructive',
          // icon: 'trash',
          handler: () => {
            this.pickTemplate('MESSAGES.TEMPLATES.LABEL_3');
          },
        },
        /*
        {
          text: this.translate.instant('MESSAGES.ACTIONS.CUSTOM'),
          // icon: 'close',
          // role: 'cancel',
          handler: () => {
            console.log('Custom clicked');
            this.message = '';
          },
        },*/
        {
          text: this.translate.instant('MESSAGES.ACTIONS.CANCEL'),
          // icon: 'close',
          role: 'cancel',
          handler: () => {
            this.analytics.track('qt_broadcast_templates_cancel', {
              team_id: this.teamId,
              ui: true,
            });
            console.log('Member options cancelled');
          },
        },
      ],
    };
    const actionSheet = await this.actionSheetController.create(options);
    await actionSheet.present();
  }

  formatPhoneNumber(phoneNumberString: string) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }

  postReply() {
    this.sms.sendMockReply({
      teamPhone: `+${this.team.teamPhoneFriendly.replace(/\D/g, '')}`,
      memberPhone: this.member.mobileNumber.full,
      replyMessage: this.messageForm.get('message').value,
      mediaData: [],
    });
  }
}
